export default {"src":"/_next/static/media/certidao-de-nascimento.182411cc.svg","height":512,"width":339,"blurWidth":0,"blurHeight":0};